export default function numberToStringWithSpace(
  value_: number | string | undefined
) {
  const value = Number(value_);
  if (value === undefined || value === Infinity) {
    return "-.--";
  } else {
    const isInteger = Number.isInteger(Number(value));
    const number_ = isInteger
      ? Number(value)
      : Number(value.toString().split(".")[0]);
    const int = String(Math.trunc(number_));
    if (int.length <= 3)
      return isInteger ? int : int + ". " + value.toString().split(".")[1];
    let space = 0;
    let number = "";

    for (let i = int.length - 1; i >= 0; i--) {
      if (space == 3) {
        number = " " + number;
        space = 0;
      }
      number = int.charAt(i) + number;
      space++;
    }

    return isInteger ? number : number + ". " + value.toString().split(".")[1];
  }
}
